export default __webpack_public_path__ + "static/media/tokodot_icon.72d143cc.svg";